import React from 'react'
import { Switch, Route, useLocation } from '@fs/zion-router'
import KidsHome from './pages/KidsHome'
import NavTabsHeader from './pages/KidsHome/NavTabs/NavTabsHeader'
import Providers from './providers'
import SplashTransitionProvider from './providers/SplashTransitionProvider'
import { isFooterVisiblePath } from './helpers/routes'

const ActivityGroup = React.lazy(() => import('./pages/Activity/ActivityGroup'))
const Avatar = React.lazy(() => import('./pages/Avatar'))
const FamilyAvatar = React.lazy(() => import('./pages/Avatar/FamilyAvatar'))
const Groups = React.lazy(() => import('./pages/Groups'))

// Create a separate component for the routes content
function RoutesContent({ path }) {
  const location = useLocation()
  const showNavTabs = isFooterVisiblePath(location.pathname)

  return (
    <>
      {showNavTabs && <NavTabsHeader />}
      <div>
        <Switch>
          <Route path="/groups" component={Groups} requirePersonalData />
          <Route exact path="/:topicId" component={KidsHome} />
          <Route exact path="/activities/familyavatars" component={FamilyAvatar} />
          <Route path={['/avatar', '/activities/familyavatars']} component={Avatar} />
          <Route path={path} component={ActivityGroup} />
        </Switch>
      </div>
    </>
  )
}

// Main PrimaryRoutes component
export default function PrimaryRoutes({ path }) {
  return (
    <Providers>
      <SplashTransitionProvider>
        <RoutesContent path={path} />
      </SplashTransitionProvider>
    </Providers>
  )
}
